<div *ngIf="client != null" class="form">
  <h2 class="mb14">Bewind beëindigen</h2>

  <form [formGroup]="form">
    <div [ngClass]="{ 'input-error': submitted && f.date.errors }">
      <label for="date" class="form-label">Einddatum bewind *</label>
      <input type="text" formControlName="date" id="date" placeholder="dd-mm-jjjj">
      <div *ngIf="submitted && f.date.errors">
        <div *ngIf="f.date.errors.required">Dit veld is verplicht.</div>
        <div *ngIf="!f.date.errors.required && f.date.errors.validDate">Dit is geen geldige datum.</div>
        <div *ngIf="!f.date.errors.required && !f.date.errors.validDate && f.date.errors.minDate">De einddatum moet na
          de instellingsdatum liggen.
        </div>
      </div>
    </div>
  </form>
  <div class="spacer"></div>
  <button (click)="cancel()" class="btn arrow-left btn-left">annuleren</button>
  <button (click)="onCreateReport('ERV')" class="btn times ml14">einde of overdracht</button>
  <button (click)="onCreateReport('ERVO')" class="btn times ml14 btn-right">overlijden</button>
</div>
